import React from 'react';
import PageLayout from '../components/PageLayout';
import SEOHead from '../components/SEOHead';

const needs = [
  'Planning',
  'Comprehensible approach',
  'Cyber security protection',
];

const whatWeDo = [
  'Collecting business information and requirements',
  'Consultant a suitable implementation',
  'Collaborating and coordinating the development process',
  'Testing solutions for correct work',
];

export default function ITConsulting() {
  return (
    <PageLayout>
      <SEOHead
        title="IT Consulting Services"
        description="DISION Tech IT consulting services improve your firm's productivity, expandability and profitability by implementing the right technology and security strategy."
        keywords="IT consulting, IT strategy, technology consulting, cybersecurity consulting, digital transformation, Ho Chi Minh"
        url="/development/it-consulting-services"
      />
      {/* Page Hero */}
      <div style={{ background: '#F9FAFB', padding: '60px 24px 50px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
            <span style={{ fontSize: '14px', color: '#6B7280' }}>Development</span>
            <span style={{ color: '#D1D5DB' }}>/</span>
            <span style={{ fontSize: '14px', color: '#0099CC', fontWeight: '500' }}>IT Consulting Services</span>
          </div>
          <h1 style={{ fontSize: 'clamp(32px, 4vw, 52px)', fontWeight: '800', color: '#111827', marginBottom: '16px', letterSpacing: '-1px', lineHeight: 1.15 }}>
            IT Consulting Services
          </h1>
          <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '640px', lineHeight: 1.7 }}>
            We support customers' IT initiatives by providing strategic, architectural, operational, and implementation planning.
          </p>
        </div>
      </div>

      {/* Why you need it */}
      <section style={{ padding: '80px 24px', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: '36px', fontWeight: '700', color: '#111827', marginBottom: '24px', letterSpacing: '-0.5px' }}>Why do you need IT consulting services from DISION Tech?</h2>
            <p style={{ fontSize: '16px', color: '#6B7280', lineHeight: 1.8, marginBottom: '28px' }}>
              If you think that a firewall or an IT guy will be your shield to protect against cyber-attacks, which can result in application downtime, theft of sensitive data, damage to reputation, compliance fines, and other adverse consequences, you are just secured in your mind.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {needs.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#0099CC', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4l3 3 5-6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  <span style={{ fontSize: '16px', color: '#374151', fontWeight: '500' }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ borderRadius: '20px', overflow: 'hidden', lineHeight: 0 }}>
            <img src="/pictures/why_Do_You_Need_49074c3699.png" alt="IT Consulting" style={{ width: '100%', height: 'auto', display: 'block' }} onError={e => { e.target.src = 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&q=80'; }} />
          </div>
        </div>
      </section>

      {/* What we do */}
      <section style={{ padding: '80px 24px', background: '#F9FAFB' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
          <div style={{ borderRadius: '20px', overflow: 'hidden', lineHeight: 0 }}>
            <img src="/pictures/what_do_we_do_073b924eab.jpg" alt="What we do" style={{ width: '100%', height: 'auto', display: 'block' }} onError={e => { e.target.src = 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=80'; }} />
          </div>
          <div>
            <h2 style={{ fontSize: '36px', fontWeight: '700', color: '#111827', marginBottom: '32px', letterSpacing: '-0.5px' }}>What do we do?</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {whatWeDo.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '18px 20px', borderRadius: '12px', background: 'white', border: '1px solid #E5E7EB' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#0099CC', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                    <span style={{ color: 'white', fontWeight: '700', fontSize: '13px' }}>{i + 1}</span>
                  </div>
                  <span style={{ fontSize: '15px', color: '#374151', lineHeight: 1.6, fontWeight: '500' }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Commitment banner */}
      <section style={{ padding: '80px 24px', background: '#111827' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(24px, 3vw, 38px)', fontWeight: '700', color: 'white', marginBottom: '24px', letterSpacing: '-0.5px', lineHeight: 1.3 }}>
            We're proud of our commitment to unparalleled results, client service, and continuous growth.
          </h2>
          <button
            style={{ backgroundColor: '#F97316', color: 'white', padding: '14px 36px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '16px', fontWeight: '600', transition: 'background-color 0.2s ease' }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EA580C'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#F97316'}
          >
            Contact us
          </button>
        </div>
      </section>
    </PageLayout>
  );
}
